module.exports = __webpack_public_path__ + "img/gr-sm-icn.fecdbc7f.svg";